var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[(_vm.questionData.descriptionBelow)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.questionData.descriptionBelow))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }